<template>
    <div class="dot-loader" :class="rootClasses">
        <div class="dot-loader--dot" v-for="dot in 3" :key="dot"/>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';


    export default {
        mixins: [
            bemMixin('dot-loader'),
        ],
        props: {
            isActive: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            rootClasses() {
                return [
                    ...this.bemFacets,
                    this.bemIf(this.isActive, 'is-active'),
                ];
            },
        },
    };
</script>
